export var readAgencies = {
    read: function (_, _a) {
        var _b;
        var readField = _a.readField;
        return (_b = readField('getAgencies')) !== null && _b !== void 0 ? _b : [];
    },
};
